import React from 'react';
import './Music.css';

class Music extends React.Component {
  render() {
    return (
      <div className="music">
        <div className="music-padding">
          <h2 className="music-h2">Über uns:</h2>
          <p className="music-p">Was 2015 als Schnapsidee auf dem Weihnachtsmarkt in Alstätte anfing, hat sich inzwischen seit mehreren Jahren als fester Bestandteil aller möglichen feiernswerter Anlässe vom Schützenfest über Firmenfeier bis zur grünen Hochzeit bewährt. Mit einem breiten Repertoire, das sich vor keiner Musikrichtung schreckt, freuen wir uns, auch Ihre Feierlichkeit zu begleiten. Dabei greifen wir auf musikalische Vielfältigkeit, eine enge Absprache mit dem oder den Feiernden sowie unsere Spontaneität zurück. Musik vom Band ist für uns in jedem Fall ein No-Go, wir verstehen uns als absolute Live-Band.</p>
          
          <h2 className="music-h2">Was uns besonders macht:</h2>
          <p className="music-p">Auch wenn unsere Wurzeln in der klassisch westmünsterländischen Feiertradition liegen, haben wir mittlerweile eine Vielfalt unterschiedlicher Feste professionell begleitet. Professionell gerade deswegen, weil mit Simon und Michael schließlich zwei unserer Mitglieder auf ihre Erfahrungen im Musikstudium zurückgreifen können. Außerdem sind wir auch konstellationsmäßig auf unterschiedliche Festivitäten vorbereitet:</p>

          <ul className="music-p">
            <li><p><b>Red Lines Akustik:</b> Den jeweiligen „Draußen-Teil“ ihrer Hochzeit oder anderer privater Feiern begleiten wir gerne mit unserem Akustiksetup, das sich gerade zu späterer Stunde immer wieder im Lagerfeuer bewährt hat.</p></li>
            <li><p><b>Red Lines Plus:</b> Auf allen Sommer- und Schützenfesten ist unser langjähriger Freund Johannes treuer Begleiter gewesen und hat durch humorvoll professionelle Moderationsfähigkeiten bisher noch jeder Feier ihren Rahmen verliehen. Aber auch, wenn es noch größer werden soll, sind wir mitsamt einer größeren Brass- und Rhythmsection buchbar. Hierbei setzen wir auf die Kooperation mit Mitgliedern der Nico-Mey Big Band Alstätte, in der wir ebenfalls Mitglieder sind.</p></li>
          </ul>
        </div>
      </div>
    )
  }
}

export default Music;


// WEBPACK FOOTER //
// ./src/components/music/Music.js